import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getAccountRequest, getProfileRequest } from 'containers/App/actions';
import { toAwaitable } from 'utils/hooks/globalState';
import { useCurrentAccount } from 'utils/hooks/globalState/baseState/useCurrentAccount';
import { useCurrentUser } from 'utils/hooks/globalState/baseState/useCurrentUser';

export const useTriggerGlobalSagas = () => {
  const dispatch = useDispatch();
  const account = useCurrentAccount();
  const profile = useCurrentUser();

  useEffect(() => {
    if (!account) {
      dispatch(getAccountRequest());
    }
    if (!profile) {
      dispatch(getProfileRequest());
    }
    // we only want this to trigger initially
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    awaitable:
      account && profile
        ? toAwaitable({ account, profile })
        : toAwaitable(undefined),
  };
};
